import React from 'react';
import {
  NoPlayersMessage,
  PlayerInner,
  PlayersCount,
  PlayersCountNoNum,
} from './final.js';

class PlayersInner extends React.Component {
  groupPlayersByTargetTime = (players) => {
    return players.reduce((groups, player) => {
      const targetTime = player._target_time || 'No time specified';
      if (!groups[targetTime]) {
        groups[targetTime] = [];
      }
      groups[targetTime].push(player);
      return groups;
    }, {});
  }

  players = () => {
    if (this.props.players.length === 0) {
      return <NoPlayersMessage message={this.props.message} />;
    } else {
      if (this.props.gameType === 'OUTDOOR') {
        return this.props.players.sort((a, b) => a._place - b._place).map(this.playerInner(this.props.flag, this.props.gameType));

      } else {
        return this.props.players.sort((a, b) => a._place - b._place).map(this.playerInner(this.props.flag, this.props.gameType));
      }
    }
  }

  playerInner = (flag, gameType) => {
    return (player, i) => {
      if (player._number_of_friends === 0)
        return <PlayerInner key={i} player={player} flag={flag} gameType={gameType} />;
      else {
        const listNumFriends = Array(player._number_of_friends + 1).fill(0);
        const listItemsFriends = listNumFriends.map((num, j) => {
          if (j === 0)
            return <PlayerInner key={`${i}-${j}`} player={player} flag={''} gameType={gameType} />;
          else
            return <PlayerInner key={`${i}-${j}`} player={player} flag={` +${j}`} gameType={gameType} />;
        });
        return listItemsFriends;
      }
    };
  }

  playersCount = () => {
    if (this.props.playersCount)
      return <PlayersCount label={this.props.label} totalPlayersNum={this.props.totalPlayersNum} numberOfPlayers={this.props.numberOfPlayers} />;
    else
      return <PlayersCountNoNum label={this.props.label} totalPlayersNum={this.props.totalPlayersNum} />;
  }

  render() {
    return (
      <React.Fragment>
        {this.playersCount()}
        <ul className="game__list">
          {this.players()}
        </ul>
      </React.Fragment>
    );
  }
}

export default PlayersInner;
